import React from "react";
import FeedsFilters from "web/react/components/feeds-filters/feeds-filters";
import FilterOverlay from "web/react/components/filter-overlay/filter-overlay";
import withReduxProvider from "web/react/redux-provider";
import { gettext } from "web/script/modules/django-i18n";
import { UniversalFiltersData } from "web/types/universal-filters";
import { usePageManager } from "../feeds-filters/feeds-filters-pagination/pagination-state";
import { useFilterManager } from "../feeds-filters/hooks/use-filter-manager";

interface FilterContainerProps {
    filters: UniversalFiltersData;
}

function FilterContainer({ filters }: FilterContainerProps): JSX.Element {
    let pageManager = usePageManager(gettext("general.filters"));
    let filterManager = useFilterManager(filters);

    const { updateFromServer } = filterManager;
    const { popPage, pushActivePage, paginationState } = pageManager;

    function handleCollapse(item): void {
        popPage(item);
        updateFromServer();
    }

    return (
        <>
            <FeedsFilters
                onPageChange={pushActivePage}
                paginationState={paginationState}
                {...filterManager}
                sidebar={true}
                onClose={handleCollapse}
            />
            <FilterOverlay {...{ filterManager, pageManager }} />
        </>
    );
}

export default withReduxProvider(FilterContainer);
